/* ============================================================
   VENTTO ESSENCE — theme.js
   Único JS del sistema. Sin carrito local: Shopify /cart.js es
   la única fuente de verdad. AddToCart (Meta Pixel / GA4) solo
   se dispara dentro del .then() de una respuesta exitosa real.
   ============================================================ */
(function () {
  'use strict';

  const CART_ADD_URL = '/cart/add.js';
  const CART_CHANGE_URL = '/cart/change.js';
  const CART_URL = '/cart.js';

  function openDrawer() {
    document.getElementById('ventto-cart-drawer')?.classList.add('open');
    document.getElementById('ventto-drawer-overlay')?.classList.add('open');
  }
  function closeDrawer() {
    document.getElementById('ventto-cart-drawer')?.classList.remove('open');
    document.getElementById('ventto-drawer-overlay')?.classList.remove('open');
    const confirm = document.getElementById('ventto-drawer-confirm');
    if (confirm) confirm.style.display = 'none';
  }

  function renderCart(cart) {
    const body = document.getElementById('ventto-drawer-body');
    const countEls = document.querySelectorAll('[data-ventto-cart-count]');
    const subtotalEl = document.getElementById('ventto-drawer-subtotal');
    if (!body) return;

    countEls.forEach((el) => { el.textContent = cart.item_count; });
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="drawer-empty">Tu carrito está vacío.</div>';
      return;
    }

    body.innerHTML = cart.items.map((item, index) => `
      <div class="drawer-line">
        <img src="${item.image ? item.image.replace('{width}', '128') : ''}" alt="${escapeHtml(item.product_title)}">
        <div class="drawer-line-info">
          <div class="name">${escapeHtml(item.product_title)}</div>
          <div class="qty-row">
            <button class="qty-btn" type="button" data-ventto-qty-change="${item.key}" data-delta="-1" aria-label="Reducir cantidad">−</button>
            <span>${item.quantity}</span>
            <button class="qty-btn" type="button" data-ventto-qty-change="${item.key}" data-delta="1" aria-label="Aumentar cantidad">+</button>
            <span style="margin-left:auto; text-decoration:underline; cursor:pointer;" data-ventto-qty-change="${item.key}" data-delta="remove">Eliminar</span>
          </div>
        </div>
        <div class="price">${formatMoney(item.final_line_price)}</div>
      </div>
    `).join('');
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function refreshCart() {
    return fetch(CART_URL)
      .then((r) => r.json())
      .then((cart) => { renderCart(cart); return cart; })
      .catch((err) => { console.error('[VENTTO] No se pudo leer el carrito:', err); });
  }

  function addToCart(variantId, quantity, triggerEl) {
    if (!variantId) {
      console.error('[VENTTO] addToCart llamado sin variantId — revisa que el botón tenga data-variant-id renderizado por Liquid.');
      return Promise.reject(new Error('missing variant id'));
    }
    if (triggerEl) triggerEl.disabled = true;

    return fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] }),
    })
      .then((r) => {
        if (!r.ok) return r.json().then((err) => Promise.reject(err));
        return r.json();
      })
      .then((addedItem) => {
        document.dispatchEvent(new CustomEvent('ventto:added_to_cart', { detail: addedItem }));
        dispatchTracking('add_to_cart', {
          product: addedItem.product_title,
          variant_id: addedItem.variant_id,
          price: addedItem.final_price / 100,
          quantity: addedItem.quantity,
        });
        return refreshCart().then(() => {
          openDrawer();
          const confirm = document.getElementById('ventto-drawer-confirm');
          if (confirm) confirm.style.display = 'flex';
          const pdpConfirm = document.getElementById('ventto-pdp-confirm');
          if (pdpConfirm) {
            pdpConfirm.style.display = 'flex';
            setTimeout(() => { pdpConfirm.style.display = 'none'; }, 3000);
          }
        });
      })
      .catch((err) => {
        console.error('[VENTTO] Add to cart falló:', err);
        alert('No pudimos agregar el producto al carrito. Intenta de nuevo.');
      })
      .finally(() => {
        if (triggerEl) triggerEl.disabled = false;
      });
  }

  function changeLine(lineKey, action) {
    if (action === 'remove') {
      return fetch(CART_CHANGE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 }),
      }).then((r) => r.json()).then((cart) => renderCart(cart));
    }
    return fetch(CART_URL).then((r) => r.json()).then((cart) => {
      const line = cart.items.find((i) => i.key === lineKey);
      if (!line) return;
      const newQty = Math.max(0, line.quantity + parseInt(action, 10));
      return fetch(CART_CHANGE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: newQty }),
      }).then((r) => r.json()).then((updatedCart) => renderCart(updatedCart));
    });
  }

  function dispatchTracking(eventName, payload) {
    document.dispatchEvent(new CustomEvent('ventto:track', { detail: { event: eventName, payload } }));
    if (window.fbq) {
      switch (eventName) {
        case 'add_to_cart':
          window.fbq('track', 'AddToCart', {
            content_ids: [String(payload.variant_id)],
            content_type: 'product',
            value: payload.price,
            currency: 'USD',
          });
          break;
        case 'view_content':
          window.fbq('track', 'ViewContent', {
            content_ids: [String(payload.variant_id)],
            content_type: 'product',
            value: payload.price,
            currency: 'USD',
          });
          break;
        case 'initiate_checkout':
          window.fbq('track', 'InitiateCheckout');
          break;
        default:
          break;
      }
    }
  }

  document.addEventListener('click', function (e) {
    const atcBtn = e.target.closest('[data-ventto-add-to-cart]');
    if (atcBtn) {
      const variantId = atcBtn.getAttribute('data-variant-id');
      const qtyTargetSelector = atcBtn.getAttribute('data-qty-target');
      const qtyInput = qtyTargetSelector ? document.querySelector(qtyTargetSelector) : null;
      const qty = qtyInput ? parseInt(qtyInput.textContent || qtyInput.value, 10) : 1;
      addToCart(variantId, qty, atcBtn);
      return;
    }

    const qtyChangeEl = e.target.closest('[data-ventto-qty-change]');
    if (qtyChangeEl) {
      changeLine(qtyChangeEl.getAttribute('data-ventto-qty-change'), qtyChangeEl.getAttribute('data-delta'));
      return;
    }

    if (e.target.closest('[data-ventto-open-cart]')) { openDrawer(); return; }
    if (e.target.closest('[data-ventto-close-cart]')) { closeDrawer(); return; }

    const checkoutBtn = e.target.closest('[data-ventto-checkout]');
    if (checkoutBtn) {
      dispatchTracking('initiate_checkout', {});
    }

    const trackEl = e.target.closest('[data-track]');
    if (trackEl) {
      dispatchTracking(trackEl.getAttribute('data-track'), {
        origin: trackEl.getAttribute('data-origin') || null,
        product: trackEl.getAttribute('data-product') || null,
        profile: trackEl.getAttribute('data-profile') || null,
      });
    }

    const qtyStepper = e.target.closest('[data-ventto-qty-step]');
    if (qtyStepper) {
      const target = document.querySelector(qtyStepper.getAttribute('data-qty-target'));
      if (target) {
        const delta = parseInt(qtyStepper.getAttribute('data-ventto-qty-step'), 10);
        const current = parseInt(target.textContent, 10) || 1;
        target.textContent = Math.max(1, current + delta);
      }
    }

    const galleryThumb = e.target.closest('[data-ventto-gallery-thumb]');
    if (galleryThumb) {
      const mainImg = document.querySelector('[data-ventto-gallery-main] img');
      const newSrc = galleryThumb.getAttribute('data-full-src');
      if (mainImg && newSrc) mainImg.src = newSrc;
    }
  });

  if (document.getElementById('ventto-drawer-overlay')) {
    document.getElementById('ventto-drawer-overlay').addEventListener('click', closeDrawer);
  }

  const pdpTop = document.getElementById('ventto-pdp-top');
  const stickyAtc = document.getElementById('ventto-sticky-atc');
  if (pdpTop && stickyAtc) {
    document.body.classList.add('has-sticky-atc');
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => {
        stickyAtc.classList.toggle('show', !entry.isIntersecting);
      }),
      { threshold: 0 }
    );
    observer.observe(pdpTop);
  }

  const pdpRoot = document.querySelector('[data-ventto-product-view]');
  if (pdpRoot) {
    dispatchTracking('view_content', {
      variant_id: pdpRoot.getAttribute('data-variant-id'),
      price: parseFloat(pdpRoot.getAttribute('data-price') || '0'),
    });
  }

  refreshCart();

  window.Ventto = { addToCart, openDrawer, closeDrawer, refreshCart };
})();

/* ============================================================
   VENTTO — Encuesta "Ayúdame a elegir" (v2 — con productos reales)
   2 preguntas simples. Al final muestra hasta 3 perfumes reales que
   coinciden (mismo criterio que el finder de la homepage) + siempre
   un botón a WhatsApp con el mensaje ya armado, para quien no quede
   convencido con las sugerencias.
   ============================================================ */
(function () {
  'use strict';
  const modal = document.getElementById('ventto-quiz-modal');
  const overlay = document.getElementById('ventto-quiz-overlay');
  const dataEl = document.getElementById('ventto-quiz-products-data');
  if (!modal || !overlay) return;

  let products = [];
  if (dataEl) {
    try { products = JSON.parse(dataEl.textContent); } catch (e) { products = []; }
  }

  const state = { gender: null, profile: null };

  const GENDER_MAP = {
    'Mujer': ['Femenino', 'Unisex'],
    'Hombre': ['Masculino', 'Unisex'],
    'No estoy seguro': ['Femenino', 'Masculino', 'Unisex'],
  };

  const PROFILE_KEYWORDS = {
    'Dulce': ['oriental', 'gourmand', 'sweet', 'vainilla'],
    'Fresco': ['citrus', 'fresh', 'aromatic', 'cítrico'],
    'Amaderado': ['woody', 'amber', 'madera'],
    'Intenso': ['spicy', 'especiad', 'oriental', 'amber'],
  };

  function openQuiz() {
    state.gender = null;
    state.profile = null;
    showStep('1');
    modal.classList.add('open');
    overlay.classList.add('open');
  }
  function closeQuiz() {
    modal.classList.remove('open');
    overlay.classList.remove('open');
  }
  function showStep(step) {
    modal.querySelectorAll('.quiz-step').forEach((el) => {
      el.hidden = el.getAttribute('data-quiz-step') !== step;
    });
  }

  function buildWhatsappMessage() {
    const parts = ['Hola VENTTO 👋 Aún no me he decidido por cuál perfume es mi ideal.'];
    if (state.gender && state.gender !== 'No estoy seguro') {
      parts.push(`Busco algo para ${state.gender.toLowerCase()}`);
    }
    if (state.profile && state.profile !== 'No estoy seguro') {
      parts.push(`con un perfil ${state.profile.toLowerCase()}`);
    }
    parts.push('Ayúdame a encontrarlo.');
    return parts.join(' ');
  }

  function familyMatchesProfile(family, profileKey) {
    if (!family || !PROFILE_KEYWORDS[profileKey]) return false;
    const f = family.toLowerCase();
    return PROFILE_KEYWORDS[profileKey].some((kw) => f.includes(kw));
  }

  function showResult() {
    const number = modal.getAttribute('data-whatsapp-number');
    const container = document.getElementById('ventto-quiz-result-actions');
    const title = document.getElementById('ventto-quiz-result-title');
    const waLink = document.getElementById('ventto-quiz-whatsapp');

    const allowedGenders = GENDER_MAP[state.gender] || GENDER_MAP['No estoy seguro'];
    let matches = products.filter((p) => allowedGenders.includes(p.gender) && familyMatchesProfile(p.family, state.profile));
    if (matches.length === 0) {
      matches = products.filter((p) => allowedGenders.includes(p.gender));
    }
    matches = matches.slice(0, 3);

    title.textContent = matches.length > 0 ? 'Estas opciones podrían gustarte' : 'Aún no tenemos una coincidencia exacta';

    if (matches.length === 0) {
      container.innerHTML = '<p class="sans" style="grid-column:1/-1; color:var(--ink-soft); text-align:center; font-size:13px;">Escríbenos por WhatsApp y te ayudamos a encontrarlo.</p>';
    } else {
      container.innerHTML = matches.map((p) => `
        <div class="finder-card">
          <img src="${p.image || ''}" alt="${p.title}">
          <div class="finder-card-body sans">
            <div class="finder-card-name" style="font-size:13px;">${p.title}</div>
            <div class="finder-card-price" style="font-size:13px;">${p.price}</div>
            <a href="${p.url}" class="btn-card solid" style="text-align:center; display:block; font-size:11px; padding:9px 6px;">Ver perfume</a>
          </div>
        </div>
      `).join('');
    }

    if (number) {
      waLink.href = `https://wa.me/${number}?text=${encodeURIComponent(buildWhatsappMessage())}`;
    }
    showStep('result');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ventto-open-quiz]')) {
      e.preventDefault();
      openQuiz();
      return;
    }
    if (e.target.closest('[data-ventto-quiz-close]') || e.target === overlay) {
      closeQuiz();
      return;
    }
    const answerBtn = e.target.closest('[data-ventto-quiz-answer]');
    if (answerBtn) {
      const question = answerBtn.getAttribute('data-question');
      const value = answerBtn.getAttribute('data-value');
      state[question] = value;
      if (question === 'gender') { showStep('2'); }
      else if (question === 'profile') { showResult(); }
    }
  });
})();


/* ============================================================
   VENTTO — Encuentra el tuyo (encuesta filtrante inline)
   Género → perfil olfativo → hasta 3 resultados reales con botón
   directo a la ficha del producto. Sin fabricar categorías: el
   perfil se infiere de la familia olfativa real guardada en
   metafields (ventto.family), agrupada en categorías amplias.
   ============================================================ */
(function () {
  'use strict';
  const root = document.getElementById('ventto-finder');
  const dataEl = document.getElementById('ventto-finder-data');
  if (!root || !dataEl) return;

  let products = [];
  try { products = JSON.parse(dataEl.textContent); } catch (e) { products = []; }

  const state = { gender: null, profile: null };

  const PROFILE_KEYWORDS = {
    dulce: ['oriental', 'gourmand', 'sweet', 'vainilla'],
    fresco: ['citrus', 'fresh', 'aromatic', 'cítrico'],
    amaderado: ['woody', 'amber', 'madera'],
    floral: ['floral'],
    especiado: ['spicy', 'especiad'],
  };

  function showStep(step) {
    root.querySelectorAll('.finder-step').forEach((el) => {
      el.hidden = el.getAttribute('data-finder-step') !== step;
    });
  }

  function familyMatchesProfile(family, profileKey) {
    if (!family) return false;
    const f = family.toLowerCase();
    return (PROFILE_KEYWORDS[profileKey] || []).some((kw) => f.includes(kw));
  }

  function renderResults() {
    const container = document.getElementById('ventto-finder-results');
    const title = document.getElementById('ventto-finder-results-title');

    let matches = products.filter((p) => p.gender === state.gender && familyMatchesProfile(p.family, state.profile));
    let fallbackUsed = false;
    if (matches.length === 0) {
      matches = products.filter((p) => p.gender === state.gender);
      fallbackUsed = true;
    }
    matches = matches.slice(0, 3);

    title.textContent = fallbackUsed
      ? 'No hay una coincidencia exacta de perfil, pero estas son ideales para ti'
      : 'Estas opciones podrían gustarte';

    if (matches.length === 0) {
      container.innerHTML = '<p class="sans" style="color:var(--ink-soft); text-align:center;">Aún no tenemos una opción exacta — escríbenos por WhatsApp y te ayudamos a encontrarla.</p>';
    } else {
      container.innerHTML = matches.map((p) => `
        <div class="finder-card">
          <img src="${p.image || ''}" alt="${p.title}">
          <div class="finder-card-body sans">
            <div class="finder-card-name">${p.title}</div>
            <div class="finder-card-price">${p.price}</div>
            <a href="${p.url}" class="btn-card solid" style="text-align:center; display:block;">Ver este perfume</a>
          </div>
        </div>
      `).join('');
    }
    showStep('results');
  }

  root.addEventListener('click', function (e) {
    const answerBtn = e.target.closest('[data-finder-answer]');
    if (answerBtn) {
      const question = answerBtn.getAttribute('data-finder-question');
      const value = answerBtn.getAttribute('data-finder-value');
      state[question] = value;
      if (question === 'gender') { showStep('profile'); }
      else if (question === 'profile') { renderResults(); }
      return;
    }
    if (e.target.closest('[data-finder-reset]')) {
      state.gender = null;
      state.profile = null;
      showStep('gender');
    }
  });
})();
